import React, { createContext, useContext } from "react";
import { createPortal } from "react-dom";

// Dashboard.jsx provides the DOM node of the slot in its header (next to the page title).
// Each tab renders its own banner (section title, last refreshed, actions) into it, so the
// banner sits in the page header while its state stays inside the tab.
export var DashboardHeaderSlotContext = createContext(null);

export function DashboardHeaderBanner(props) {
  var slotNode = useContext(DashboardHeaderSlotContext);
  if (!slotNode) return null;
  return createPortal(props.children, slotNode);
}
